module.exports = __webpack_public_path__ + "static/img/icon_s10.1e81ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_s10.png
// module id = NMn0
// module chunks = 21